<template>
    <filters-block :open="open" :collapse="collapse" class="price-filter relative" @toggle="getMaxPrice" :title="localizeList.availabilityUpper">
        <div v-show="priceLoader" class="price-loader">
            <base-loader size="50" weight="3" />
        </div>
        <!-- <div class="price-block">
        <p class="price-text">{{localizeList.priceUpper}}: <span class="blue-text">
            {{correctPrice(availabilityPriceData[0], true)}} {{getCurrencyDisplayBySettings(rate)}} – {{correctPrice(availabilityPriceData[1], true)}} {{getCurrencyDisplayBySettings(rate)}}</span>
        </p>
        <base-slider v-model="availabilityPriceData"
                     @change="changePrice($event)"
                     :size="tourPriceLimit"/>
    </div> -->
        <div class="common-price-block">
            <p class="price-text">{{localizeList.availabilityPriceRangeUpper}}</p>
            <div class="price-inputs">
                <input type="text" class="price-input"
                       maxlength="9"
                       @input="(event) => availabilityPriceData[0] = maskInputForNumber(event, 0)"
                       :value="availabilityPriceData[0]"
                       @change="changePrice(availabilityPriceData)">
                <span class="dash"></span>
                <input type="text" class="price-input"
                       maxlength="9"
                       @input="(event) => availabilityPriceData[1] = maskInputForNumber(event, 0)"
                       :value="availabilityPriceData[1]"
                       @change="changePrice(availabilityPriceData)">
            </div>
        </div>
    </filters-block>
</template>

<script>
    import FiltersBlock from "./filtersBlock";

    export default {
        name: "priceFilter",
        components: {
            FiltersBlock
        },
        props: {
            rate: {
                type: Object,
                required: true
            },
            tourSettings: {
                type: Object,
                required: true
            },
            availabilityPrice: {
                type: Array,
                required: true
            },
            availabilityPlace: {
                type: Array,
                required: true
            },
            priceLoader: {
                type: Boolean,
                required: true
            },
            tourPriceLimit: {
                type: Array,
                required: true
            },
            collapse: {
                type: Number,
                default: 0
            },
            open: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                // availabilityPriceData: [0, 10000]
                availabilityPriceData: []
            }
        },
        computed: {
            isShowBusTransferPlaces() {
                return this.tourSettings?.IsShowBusTransferPlaces
            },
            IsShowRwtTransferPlaces() {
                return this.tourSettings?.IsShowRwtTransferPlaces
            },
        },
        methods: {
            maskInputForNumber(event, range) {
                return this.$parent.$parent.maskInputForNumber(event, range);
           },
            changePrice(e) {
            if ((this.availabilityPriceData[0] > this.availabilityPriceData[1]) && this.availabilityPriceData[1]) {
                this.availabilityPriceData[0] = this.availabilityPriceData[1];
            }
                this.$parent.$parent.availabilityPrice = [...e];
                this.$parent.$parent.changePrice(e);
            },
            changeTourPlace(n, e) {
                this.$parent.$parent.changeTourPlace(n, e);
            },
            correctPrice(price, round) {
                return this.$parent.$parent.correctPrice(price, round);
            },
            getCurrencyDisplayBySettings(rate) {
                if (!rate) return "";

                return this.$parent.$parent.getCurrencyDisplayBySettings(rate);
            },
            getMaxPrice() {
                // this.$parent.$parent.getMaxPrice();
                this.$emit("toggle")
            }
        },
        watch: {
            availabilityPrice: {
                immediate: true,
                handler(val) {
                    this.availabilityPriceData = [...val]
                }
            }
        }
    }
</script>

<style scoped>

    .price-filter .price-block {
        margin-bottom: 40px;
        width: calc(100% - 20px);
    }

    .price-filter .price-block .price-text {
        font-weight: 400;
        font-size: 15px;
        line-height: 18px;
        color: var(--dark-1-color);
        margin-bottom: 24px;
    }

    .price-filter .availability-checkbox-group-wrap .default {
        display: flex;
        align-items: end;
        gap: 20px;
    }

    .price-filter .availability-checkbox-group-wrap p {
        font-weight: 400;
        font-size: 15px;
        line-height: 18px;
        color: var(--dark-1-color);
        margin-bottom: 14px;
    }

    .price-filter .availability-checkbox-group {
        display: flex;
    }

    .price-loader {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: rgba(200, 200, 200, .5);
    }

    .common-price-block {
      flex: 0 0 300px;
      width: 300px;
      display: flex;
      flex-direction: column;
      gap: 15px;
      margin-bottom: 20px;
    }

    .common-price-block .price-text {
      font-size: 15px;
    }

    .common-price-block .price-inputs {
      display: flex;
      gap: 5px;
    }

    .common-price-block .price-input {
      width: 135px;
      height: 30px;
      border: 2px solid var(--lighten-7-color);
      padding: 5px;
      font-size: 16px;
    }

    .common-price-block .price-inputs input:focus {
      border: 2px solid var(--primary-color);
      outline: none;
    }

    .common-price-block .dash {
        align-self: center;
        display: flex;
        background-color: var(--lighten-7-color);
        height: 2px;
        width: 15px;
    }
</style>